import React from 'react';
import { useAuth } from 'contexts/AuthContext';
import './branch-switcher.css';

// Lets a merchant owner view all branches (default) or focus a single branch.
// Changing the selection reloads so every page refetches with the new scope.
function BranchSwitcher() {
  const {
    isMerchant, branches, selectedBranchId, setSelectedBranchId,
  } = useAuth();

  if (!isMerchant || !branches || branches.length < 2) return null;

  const onChange = (e) => {
    setSelectedBranchId(e.target.value);
    window.location.reload();
  };

  return (
    <label className='branch-switcher'>
      <span className='branch-switcher-label'>Branch</span>
      <select className='branch-switcher-select' value={selectedBranchId} onChange={onChange}>
        <option value=''>All branches</option>
        {branches.map((b) => (
          <option key={b.id} value={b.id}>{b.name || `#${b.id}`}</option>
        ))}
      </select>
    </label>
  );
}

export default BranchSwitcher;
